import productTile from './product-tile';
import teaserContainer from './teaser-container';

/**
 * @param {import('../../../type-definitions').SearchResult} result - search result
 * @returns {string} product results HTML
 */
export default result => {
    if (!result) {
        return '';
    }

    const {products} = result;

    return `
        ${products
            .map((product, index) => {
                const rowClass = [];

                // defer all tile images except the first 6 that are in the viewing area
                if (index > 5) {
                    product.lazyLoading = true;
                } else {
                    product.lazyLoading = false;
                }

                if (index % 2 === 0) {
                    rowClass.push('first-when-2-in-row');
                } else if (index % 3 === 0) {
                    rowClass.push('first-when-3-in-row');
                }

                if (product.swatches?.length) {
                    const selectedSwatch = product.swatches.find(swatch => swatch.preselectCurrentSwatch === true);
                    if (selectedSwatch?.flags) {
                        try {
                            product.flags = JSON.parse(selectedSwatch.flags);
                        } catch (e) {
                            product.flags = [];
                        }
                    }
                }

                if (!product.isPromoTile) {
                    return `
                        <li class="xlt-producttile grid-tile ${rowClass.join(' ')}">
                            ${productTile(product)}
                        </li>
                    `;
                }

                return `
                    <li class="xlt-producttile grid-tile category-promotion asset-width-${
                        product.width
                    } ${rowClass.join(' ')}" data-position="${product.pos}">
                        ${teaserContainer(product.customizedAssets)}
                    </li>
                `;
            })
            .join('')}
    `;
};
